import script from "./PayrollReport.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollReport.vue?vue&type=script&setup=true&lang=js"

import "./PayrollReport.vue?vue&type=style&index=0&id=3f03ec42&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f03ec42"]])

export default __exports__